
export const CONTENT_TYPE_APPLICATION_JSON = 'application/json'